import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from '../../services/auth.service';
import { apiUrl } from '../../../environments/environment';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-org-privacy',
  templateUrl: './org-privacy.component.html',
  styleUrls: ['./org-privacy.component.scss']
})
export class OrgPrivacyComponent implements OnInit {

  response:any;
  userDetails:any;
  apiLink = apiUrl+'/api/';

  /** Reading progress, 0-100, driven by the document pane's scroll position. */
  readProgress = 0;

  /** Whose policy this is — shown in the header so it is clearly not Verdentum's. */
  get orgName(): string {
    const org = this.userDetails && this.userDetails.user && this.userDetails.user.organization;
    return (org && (org.pm_organization || org.org_name || org.name)) || '';
  }

  onDocScroll(ev: any) {
    const el = ev && ev.target;
    if (!el) return;
    const max = el.scrollHeight - el.clientHeight;
    this.readProgress = max > 0 ? Math.min(100, Math.round((el.scrollTop / max) * 100)) : 100;
  }

  constructor(
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private authService: AuthService
  ) {
    this.getUserDetails();
  }

  ngOnInit(): void {
  }

  async getUserDetails() {
    let userDetails = await this.authService.getUserDetails();
    if(userDetails) this.userDetails = userDetails;
    
    // Check if organization privacy policy already accepted
    if(this.userDetails.user.org_privacy_policy == 1 || !this.userDetails.user.org_privacy_policy_text || this.userDetails.user.org_privacy_policy_text.length === 0) {
      await this.authService.setUserDetails({
        type: this.userDetails.type,
        token: this.userDetails.token,
        user: [this.userDetails.user]
      });
      this.router.navigate(['intro/video']);
    }
  }

  async updatePrivacy() {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';
    
    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'usermgmt/update_opp', {}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      this.userDetails.user.org_privacy_policy = 1;
      this.authService.setUserDetails({
        type: this.userDetails.type,
        token: this.userDetails.token,
        user: [this.userDetails.user]
      });
      this.router.navigate(['intro/video']);
    });
  }

  async logout() {
    await this.authService.removeUserDetails();
    this.authService.trackAuthStatus();
  }

}
